import { Select, SelectProps } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { MessageTemplatePurpose, messageTemplatePurposes } from '../message-template'

export function TemplatePurposeSelect({ ...props }: SelectProps<MessageTemplatePurpose>) {
    const { t } = useTranslation()

    return (
        <Select
            options={messageTemplatePurposes.map((purpose) => ({
                value: purpose,
                label: t(`templatePurposes.${purpose}`),
            }))}
            {...props}
        />
    )
}
